module.exports = __webpack_public_path__ + "img/dq.18df4221.svg";